import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';

// Must be the last child of a scroll area. It overlays the rows at the bottom edge while more are
// below, and takes no space, so it is hidden once the end of the area is in view.
export function ScrollFade() {
	const endRef = useRef<HTMLDivElement>(null);
	const [isAtEnd, setIsAtEnd] = useState(true);

	useEffect(() => {
		if (!endRef.current) {
			return;
		}

		const observer = new IntersectionObserver(([entry]) => setIsAtEnd(entry.isIntersecting));
		observer.observe(endRef.current);

		return () => observer.disconnect();
	}, []);

	return (
		<>
			<StyledEnd ref={endRef} />
			{!isAtEnd && <StyledFade />}
		</>
	);
}

const StyledEnd = styled.div`
	height: 1px;
	margin-top: -1px;
`;

const StyledFade = styled.div`
	position: sticky;
	bottom: 0;
	flex: none;
	height: ${token.spacing9};
	margin-top: calc(-1 * ${token.spacing9});
	background: linear-gradient(to bottom, rgb(255 255 255 / 0%), ${token.white});
	pointer-events: none;
`;
